<template>
  <sui-page>
    <sui-page-contents>
      <h3
        ref="pageNm"
        class="comm_tit01"
      >
        팝업 테스트
      </h3>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="사용자 명(사용자 선택)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-user-select
              :selectedUser="selectedUser"
              :readonly="false"
              :placeholder="'사용자선택 단건'"
              :checkboxMode="false"
              @selected="onSelectedUser"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="사용자 명(사용자 선택-복수건)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-user-multi-select
              :selectedUserMulti="selectedUserMulti"
              :readonly="false"
              :placeholder="'사용자선택 복수건'"
              :checkboxMode="true"
              @selected="onSelectedUserMulti"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="사용자 명(사용자 선택-그리드)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-user-grid-select
              ref="userSelectGrid"
              :selectedUser="selectedUserGrid"
              @selected="onSelectedUserGrid"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="사용자 명(임직원 선택 - Knox)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-emp-select
              :selectedKnoxUser="selectedKnoxUser"
              :checkboxMode="false"
              :disabled="false"
              :fixedIcon="true"
              @selected="onSelectedKnox"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="사용자 명(임직원 선택-복수건 - Knox)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-emp-multi-select
              :selectedKnoxUserMulti="selectedKnoxUserMulti"
              :checkboxMode="true"
              :disabled="false"
              :fixedIcon="true"
              @selected="onSelectedKnoxMulti"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="부서 명(단건)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-dept-select
              ref="requestDept"
              :selectedDept="selectedDept"
              @selected="onSelectedDept"
            />
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onDeptReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="부서 명(복수건)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-dept-multi-select
              ref="requestDeptMulti"
              :selectedDeptMulti="selectedDeptMulti"
              @selected="onSelectedDeptMulti"
            />
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onDeptMultiReset"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="담당자 유형ID"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model="frame0.picTypeId"
              max-length="100"
              style="width: 50%;"
              @keyup.enter="onPicClick"
            />
            <sui-button
              type="button"
              class="comm_btn_scr"
              @click="onPicClick"
            >
              담당자 유형 조회
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="프로그램 명(프로그램 선택)"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-program-select
              :selectedPrg="selectedPrg"
              :readonly="true"
              @selected="onSelectedPrg"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="위치정보"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-location-info-select
              :readonly="true"
              :selectMode="true"
              :selectedLocation="selectedLocation"
              :onlyFloorSelection="true"
              siteId="C380AU"
              :siteDisabled="true"
              @selected="onSelectedLocation"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="업체"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-vendor-select
              ref="vendorSelect"
              :selectedCompany="selectedCompany"
              :readonly="true"
              @selected="onSelectedCompany"
            />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="상생업체"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <bqms-vendor-select
              ref="connVendorSelect"
              :selected="bqmsCompany"
              :readonly="true"
              :buttonDisable="true"
              @selected="onSelectedbqmsCompany"
            />
          </div>
        </div> -->
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="GBM 선택"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-site-gbm-select
              :selectedGbmInfo="selectedGbmInfo"
              :readonly="false"
              @selected="onSelectedSiteInfo"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="CostCenter 선택"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <cmp-cost-center-select
              :selectedCostCenter="selectedCostCenter"
              :readonly="false"
              @selected="onSelectedCostCenter"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="오즈 레포트"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-button
              type="button"
              class="comm_btn_scr"
              @click="onOzReportClick"
            >
              오즈 레포트 샘플
            </sui-button>
          </div>
        </div>
        <!--div class="row">
          <div class="col-xs-2">
            <sui-input-label
              label="오즈 레포트 POST 방식"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-button
              type="button"
              class="comm_btn_scr"
              @click="onOzReportPostClick"
            >
              오즈 레포트 샘플
            </sui-button>
          </div>
        </div-->
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMY_00003', // eslint-disable-line vue/name-property-casing
  components: {
  },
  data() {
    return {
      frame0: {
        //  usrName: '',
        //  epId: '',
        //  knoxUsrName: '',
        //  knoxEpId: ''
        deptName: '',
        picTypeId: '',
      },
      selectedUser: {
        userName: '',
        epid: '',
      },
      selectedUserMulti: {
        userName: '',
        epid: '',
      },
      selectedUserGrid: [{
        userName: '성현석',
        userId: 'M190412040728C609390',
      }, {
        userName: '한병탁',
        userId: 'P190425023412C607938',
      }],
      selectedKnoxUser: {
        userName: '',
        epId: '',
      },
      selectedKnoxUserMulti: {
        userName: '',
        epId: '',
      },
      selectedDept: {
        deptName: '',
        deptId: '',
      },
      selectedDeptMulti: {
        // deptName: '',
        // deptId: '',
      },
      selectedPrg: {
        programName: '',
        programId: '',
      },
      selectedCompany: {
        companyId: '',
        companyName: '',
      },
      selectedLocation: {
        locationName: 'test1',
        locationId: 'test1',
      },
      bqmsCompany: {
        connectionCompanyNumber: '',
      },
      selectedGbmInfo: {
        gbmCode: '',
        gbmName: '무선',
      },
      selectedCostCenter: {
        costCenterId: '',
        costCenterName: '',
      },


      // UserId는 위 아래 형태중 편하신대로 사용하시면 됩니다.
      // userList: ['M190412040728C609390', 'P190425023412C607938'],
      // userList: [],
      // userList: [{ userId: 'M190412040728C609390' }, { userId: 'P190425023412C607938' }],
    };
  },


  mounted() {
  },
  methods: {
    onDeptReset() {
      this.$refs.requestDept.reset();
    },
    onDeptMultiReset() {
      this.$refs.requestDeptMulti.reset();
    },
    onSelectedUser() {
      console.log(`${this.selectedUser.userName}+' '+${this.selectedUser.epId}`);
      console.log(this.selectedUser);
      // eslint-disable-next-line max-len
      this.selectedUser.userName = `${this.selectedUser.userName}/${this.selectedUser.knoxId}/${this.selectedUser.departmentName}`;
    },
    onSelectedUserMulti(user) {
      const userInfoData = [];
      console.log(user);
      utils.forEach(user, (value, key) => {
        userInfoData.push({
          userName: user[key].userName,
          epId: user[key].epid,
        });
        console.log(`${'데이터 갯수: '}${userInfoData.length}/${userInfoData[key].userName}/${userInfoData[key].epId}`);
      });
    },
    onSelectedUserGrid(user) {
      const userInfoData = [];
      console.log(user);
      utils.forEach(user, (value, key) => {
        userInfoData.push({
          userName: user[key].userName,
          epId: user[key].epid,
        });
        console.log(`${'데이터 갯수: '}${userInfoData.length}/${userInfoData[key].userName}/${userInfoData[key].epId}`);
      });
      this.selectedUserGrid = user;
      // this.userList = user;
    },
    onSelectedKnox() {
      console.log(`${this.selectedKnoxUser.userName}/${this.selectedKnoxUser.epId}`);
      this.selectedKnoxUser.userName = `${this.selectedKnoxUser.userName}/${this.selectedKnoxUser.epId}`;

      //  Knox 정보 저장 (단건)
      // const epId = [this.selectedKnoxUser.epId];
      // const epNo = [this.selectedKnoxUser.epNo];
      // this.onSaveKnoxInfo(epId, epNo);
    },
    onSelectedKnoxMulti(knox) {
      const knoxInfoData = [];
      console.log(knox);
      utils.forEach(knox, (value, key) => {
        knoxInfoData.push({
          userName: knox[key].cn,
          epId: knox[key].epid,
        });
        console.log(`${'데이터 갯수: '}${knox.length}/${knoxInfoData[key].userName}/${knoxInfoData[key].epId}`);
        this.selectedKnoxUserMulti.userName = `${knoxInfoData[key].userName}/${knoxInfoData[key].epId}`;
      });

      // Knox 정보 저장 (복수 건)
      // const epId = [];
      // const epNo = [];
      // utils.forEach(knox, (value, key) => {
      //   epId.push(knox[key].epid);
      //   epNo.push(knox[key].employeenumber);
      // });
      // this.onSaveKnoxInfo(epId, epNo);
    },
    onSelectedDept() {
      console.log(this.selectedDept);
      console.log(`${this.selectedDept.deptName}/${this.selectedDept.deptId}`);
    },
    onSelectedDeptMulti(dept) {
      const deptInfoData = [];
      console.log(dept);
      utils.forEach(dept, (value, key) => {
        deptInfoData.push({
          deptName: dept[key].value,
          deptId: dept[key].id,
        });
        console.log(`${'데이터 갯수: '}${dept.length}/${deptInfoData[key].deptName}/${deptInfoData[key].deptId}`);
      });
    },
    onSelectedPrg() {
      console.log(`${this.selectedPrg.programName}/${this.selectedPrg.programId}`);
    },
    // onDeptClick(){
    //   let iptDeptName = "";
    //   if(this.frame0.deptName !== ""){
    //     iptDeptName = this.frame0.deptName;
    //   }
    //   util.openLayerPopup('PGE_CMY_00004', this.onDeptPopupCallback, {
    //     pageInitialData: { iptDeptName : iptDeptName },
    //     size: 'md'
    //   });
    // },
    // onDeptPopupCallback(nodeData) {
    //   if (nodeData !== 'undefined' && nodeData !== '' && nodeData !== null){
    //     console.log(nodeData)
    //
    //   }
    // },
    onPicClick() {
      utils.openLayerPopup('PGE_CMZ_00006', this.onPicPopupCallback, {
        pageInitialData: {},
        size: 'xl',
      });
    },
    onPicPopupCallback(objPicType) {
      //      utils.alert(JSON.stringify(objPicType), this.$t('MSG_BTN_CFRM'), () => {});
      if (utils.isEmpty(objPicType) === false) {
        this.frame0.picTypeId = objPicType[0].picTypeId;
      }
    },
    onSelectedCompany(data) {
      console.log(data);
      console.log(this.selectedCompany.companyId, this.selectedCompany.companyName);
      this.$refs.connVendorSelect.focus();
      // this.$refs.connVendorSelect.reset();
    },
    onSelectedLocation(data) {
      console.log(data);
    },
    onSelectedbqmsCompany(data) {
      console.log(data);
      console.log(this.bqmsCompany.connectionCompanyNumber);
      this.$refs.vendorSelect.focus();
      // this.$refs.vendorSelect.reset();
    },

    // Knox 정보 저장
    // onSaveKnoxInfo(epId, epNo) {
    //   //  knox 조회 후 저장
    //   const pageId = 'PGE_CMY_00002';
    //   http.request(pageId, 'DTS_CMY_00007', {
    //     query: {
    //       epId: utils.join(epId, '|'),
    //       epNo: utils.join(epNo, '|'),
    //     },
    //   }).then(() => {
    //     console.log('저장 되었습니다.');
    //   }).catch(() => {
    //     console.log('저장에 실패 하였습니다.');
    //   });
    // },
    // onSelectedSiteInfo(gbm) {
    //   const gbmInfoData = [];
    //   console.log(gbm);
    //   utils.forEach(gbm, (value, key) => {
    //     gbmInfoData.push({
    //       gbmName: gbm[key].gbmName,
    //       gbmCode: gbm[key].gbmCode,
    //     });
    //     console.log(`${'데이터 갯수: '}${gbmInfoData.length}/${gbmInfoData[key].gbmName}/${gbmInfoData[key].gbmCode}`);
    //   });
    // },
    onSelectedSiteInfo() {
      console.log(`${this.selectedGbmInfo.gbmName}+' '+${this.selectedGbmInfo.gbmCode}`);
      console.log(this.selectedGbmInfo);
      // this.selectedGbmInfo.gbmName = `${this.selectedGbmInfo.gbmName}/${this.selectedGbmInfo.gbmCode}`;
    },
    onSelectedCostCenter(objCostCenter) {
      console.log('####this.selectedCostCenter#####', this.selectedCostCenter);
      console.log('####objCostCenter#####', objCostCenter);
    },
    onOzReportClick() {
      const reportNm = 'sample.ozr';
      const jsonUrl = '/api/v1/common/ozsample/codes/COD_TASK_MNTR_RQS_STT';
      utils.openOzReport(reportNm, jsonUrl);
    },
    onOzReportPostClick() {
      const reportNm = 'sample.ozr';
      const jsonUrl = '/api/v1/common/ozsample/codes/COD_TASK_MNTR_RQS_STT';
      utils.openOzReportPost(reportNm, jsonUrl);
    },
  },
};
</script>
<style scoped>
</style>
